import React, { FC } from 'react';
import { StationSummaryCardProps } from './StationSummaryCard.types';
import { AllieCard, AllieText } from '../../../components';
import {
  ProductionOrderStatus,
  AllieProductionOrderStatusChip,
} from '../ProductionOrderStatusChip/ProductionOrderStatusChip';
import {
  StationSummaryStyled,
  FlexContainer,
  StyledStationTitleLink,
} from './StationListSummaryCard.styles';
import { OEEContainer } from './components/OEEContainer';
import { POField } from './components/POField';
import { ProgressContainer } from './components/ProgressContainer';
import { ShiftField } from './components/ShiftField';
import { Stats } from './components/Stats';
import { AllieClockIcon, AllieFileIcon } from '../../../styling/icons';
import {
  StyledProductionOrderStatusChipMobileContainer,
  ItemsContainer,
  IconMobileContainer,
  StyledClockIconMobileContainer,
  EllipsisTextContainer,
} from './StationSummaryCardMobileApp.styles';

const mapProductionStatusBorderColor: Record<string, string> = {
  in_progress: 'none',
  stopped: 'var(--allie-color-error-main)',
  paused: 'none',
  no_productions: 'none',
  technical_stop: 'none',
};

/**
 * AllieStationSummaryCardMobileApp
 * Versión específica para Mobile App del StationSummaryCardV2
 *
 * Creada para permitir customizaciones específicas de la app móvil
 * sin afectar la implementación web original.
 */
export const AllieStationSummaryCardMobileApp: FC<StationSummaryCardProps> = ({
  title,
  data,
  barData,
  labels,
  onClick,
  className,
  lastSectionType,
  production,
  OEE,
  statusLabel,
  shiftEndsAt,
  shiftName,
  shiftStartsAt,
  trackingOnClickEvent,
  isMobile = false,
}) => {
  // //  AllieCloudMoon,
  // AlliePlainCalendar,
  // AllieCalendarCheckIcon,
  // AllieClockIcon,
  // AllieTagOutline,

  const isTechnicalStop =
    lastSectionType === 'neutral' && production.status === ProductionOrderStatus.STOPPED;
  return (
    <StationSummaryStyled className={className}>
      <AllieCard
        // onClick={() => isMobile && onClick()}
        style={{
          borderRadius: '8px',
          padding: '16px',
          boxSizing: 'border-box',
          boxShadow: 'none',
          // eslint-disable-next-line max-len
          border: `1px solid ${
            production.status === 'stopped'
              ? `${
                  isTechnicalStop
                    ? mapProductionStatusBorderColor[ProductionOrderStatus.TECHNICAL_STOP]
                    : mapProductionStatusBorderColor[production.status]
                }`
              : 'var(--allie-color-neutral-20)'
          }`,
        }}
        content={{
          style: {
            padding: 0,
          },
          children: (
            <FlexContainer gap={24} flexDirection="column">
              <FlexContainer flexDirection="column" gap={16}>
                <FlexContainer
                  gap={13}
                  alignItems={isMobile ? 'flex-start' : 'center'}
                  justifyContent={'space-between'}
                >
                  <StyledStationTitleLink
                    isMobile={isMobile}
                    // onClick={() => {
                    //   trackingOnClickEvent && trackingOnClickEvent('Station Name', title);
                    //   onClick();
                    // }}
                    // href={href}
                  >
                    <span>{title}</span>
                  </StyledStationTitleLink>
                  <StyledProductionOrderStatusChipMobileContainer>
                    <AllieProductionOrderStatusChip
                      status={
                        isTechnicalStop ? ProductionOrderStatus.TECHNICAL_STOP : production.status
                      }
                      statusLabel={statusLabel}
                    />
                  </StyledProductionOrderStatusChipMobileContainer>
                </FlexContainer>
                <ItemsContainer>
                  <FlexContainer
                    gap={16}
                    justifyContent="space-between"
                    alignItems="center"
                    style={{ padding: 'var(--allie-spacing-md) 0' }}
                  >
                    <FlexContainer gap={8}>
                      <IconMobileContainer>
                        <AllieFileIcon allieColor="neutral-50" color="neutral-50" />
                      </IconMobileContainer>
                      <AllieText type="body1">{labels.productionOrder}</AllieText>
                    </FlexContainer>
                    <AllieText type="body1" weight={600}>
                      {production.legacyId ?? '-'}
                    </AllieText>
                  </FlexContainer>
                  <FlexContainer
                    justifyContent="space-between"
                    gap={16}
                    style={{ padding: 'var(--allie-spacing-md) 0' }}
                  >
                    <FlexContainer gap={8}>
                      <IconMobileContainer>
                        <StyledClockIconMobileContainer>
                          <AllieClockIcon allieColor="neutral-50" color="neutral-50" />
                        </StyledClockIconMobileContainer>
                      </IconMobileContainer>
                      <AllieText type="body1">{labels.shift}</AllieText>
                    </FlexContainer>

                    <AllieText type="body1" weight={600}>
                      {shiftName}
                    </AllieText>
                  </FlexContainer>

                  {data.map(({ label, value, icon }, index) => (
                    <FlexContainer
                      justifyContent="space-between"
                      gap={16}
                      key={index}
                      style={{
                        padding: 'var(--allie-spacing-md) 0',
                        overflow: 'hidden',
                        textOverflow: 'ellipsis',
                        whiteSpace: 'nowrap',
                      }}
                    >
                      <FlexContainer gap={8}>
                        {icon && <IconMobileContainer>{icon}</IconMobileContainer>}
                        <AllieText type="body1">{label}</AllieText>
                      </FlexContainer>
                      <EllipsisTextContainer>
                        <AllieText type="body1" weight={600} className="ellipsis-text">
                          {value}
                        </AllieText>
                      </EllipsisTextContainer>
                    </FlexContainer>
                  ))}
                </ItemsContainer>

                <ProgressContainer
                  barData={barData}
                  shiftEndsAt={shiftEndsAt}
                  shiftStartsAt={shiftStartsAt}
                  progressBarHeight="20px"
                />
              </FlexContainer>
            </FlexContainer>
          ),
        }}
      />
    </StationSummaryStyled>
  );
};
